"use client"

import type { TemplateItem } from "@/app/store/api/templateApi"
import { trackEvent } from "@/lib/mixpanel"

interface TemplateSlideCardProps {
  template: TemplateItem
  onClick: () => void
  onUseTemplate?: () => void
}

export function TemplateSlideCard({ template, onClick, onUseTemplate }: TemplateSlideCardProps) {
  const thumbnail =
    template.thumbnailUrl ||
    (template.slideTemplates?.length ? template.slideTemplates[0].thumbnailUrl : null)

  return (
    <div className="group relative flex flex-col overflow-hidden rounded-2xl border border-slate-100 bg-white border border-slate-200 transition-all hover:shadow-lg hover:border-slate-300 duration-200">
      {/* Thumbnail */}
      <div
        onClick={() => { trackEvent("Template Previewed", { template_id: template._id, template_name: template.name }); onClick(); }}
        className="w-full aspect-video p-2 overflow-hidden relative cursor-pointer"
      >
        {thumbnail ? (
          <img
            src={thumbnail}
            alt={template.name}
            className="w-full h-full object-cover border border-slate-200 transition-transform rounded-xl duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-slate-100">
            <span className="text-xs text-slate-400">No preview</span>
          </div>
        )}
        {/* Hover overlay */}
        <div className="absolute inset-2 bg-black/0 rounded-xl group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
          <div className="flex flex-col items-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-4 group-hover:translate-y-0">
            <button
              onClick={(e) => {
                e.stopPropagation()
                trackEvent("Template Previewed", { template_id: template._id, template_name: template.name })
                onClick()
              }}
              className="px-4 py-2 w-full bg-white/90 backdrop-blur-sm rounded-full text-[11px] font-bold text-slate-800 shadow-lg hover:bg-white transition-all cursor-pointer"
            >
              Preview
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation()
                onUseTemplate?.()
              }}
              className="px-4 py-2 w-full bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-[11px] font-bold transition-all hover:scale-105 active:scale-95 shadow-lg shadow-blue-500/20 cursor-pointer"
            >
              Use Template
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-1 flex-col pb-3 pt-1 px-3">
        <h3
          onClick={onClick}
          className="font-bold text-sm text-slate-900 line-clamp-1 cursor-pointer hover:text-blue-600 transition-colors"
        >
          {template.name}
        </h3>
      </div>
    </div>
  )
}
